import { useEffect, useRef, useState } from "react";
// import "./NewVendor.css";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  OverlayTrigger,
  Table,
  Tooltip,
  InputGroup,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import DynamicPagination from "../../components/DynamicPagination ";
import {
  IconPlus,
  IconUserCheck,
  IconUserOff,
  IconTrash,
  IconXboxX,
  IconCircleCheck,
  IconBuildingBank,
  IconBox,
  IconPaperclip,
  IconEye,
  IconCreditCard,
  IconEdit,
  IconMessageCircle,
  IconSearch,
  IconLayoutGridFilled,
  IconLayoutListFilled,
  IconFileTypeXls,
  IconFilter,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import { toast } from "react-toastify";
import { hasPermission } from "../../utils/_helpers";
import CustomerCard from "./CustomerCard";
import View_DetailsProduct from "./ViewDetail/View_DetailsCustomer";
import { useSelector } from "react-redux";
import useIdleLogout from "../../hooks/useIdleLogout";
import CustomerListUI from "./CustomerListUI";
import axiosInstance from "../../api/axiosInstance";
import Filters from "./FiltersModal/Filters";

const ContactList = () => {
  const [page, setPage] = useState(1);
  // const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isListView, setIsListView] = useState(false);
  const [limit, setLimit] = useState(50);

  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const filterBtnRef = useRef(null);
  const [typeFilter, setTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [createdFrom, setCreatedFrom] = useState(null);
  const [createdTo, setCreatedTo] = useState(null);
  const [globalTotal, setGlobalTotal] = useState(0);

  const navigate = useNavigate();
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });
  const [isCardOpen, setIsCardOpen] = useState({
    show: false,
    auto_id: null,
    primary_email: null,
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    user: null,
    message: "",
  });

  const { data: customers, postData: fetchCustomers } = usePostRequest(
    API_ENDPOINTS.GET_CUSTOMER,
  );

  const { isLoading, postData: updateCustomerStatus } = usePostRequest(
    API_ENDPOINTS.CUSTOMER_STATUS_UPDATE,
  );

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setPage(1);
    setLimit(selectedLimit);
  };

  useEffect(() => {
    fetchCustomers({
      page,
      limit,
      search: searchTerm || undefined, // Pass search term to API
      type: typeFilter || undefined,
      active:
        statusFilter === "active"
          ? true
          : statusFilter === "inactive"
            ? false
            : undefined,
      created_date_from: createdFrom
        ? moment(createdFrom).format("YYYY-MM-DD")
        : undefined,
      created_date_to: createdTo
        ? moment(createdTo).format("YYYY-MM-DD")
        : undefined,
    });
  }, [page, limit, isSearchClicked]);

  const getPaginationTotal = (pagination) =>
    pagination?.totalCustomers ??
    pagination?.totalRecords ??
    pagination?.totalItems ??
    pagination?.total ??
    0;

  const filteredTotal = getPaginationTotal(customers?.pagination);

  useEffect(() => {
    if (!typeFilter && !statusFilter && !createdFrom && !createdTo) {
      setGlobalTotal(getPaginationTotal(customers?.pagination));
    }
  }, [customers]);

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    fetchCustomers({ page, limit });
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during deactivation.");
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setTypeFilter("");
    setStatusFilter("");
    setCreatedFrom(null);
    setCreatedTo(null);
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleFiltersApply = (values) => {
    setTypeFilter(values.type || "");
    setStatusFilter(values.status || "");
    setCreatedFrom(values.createdFrom || null);
    setCreatedTo(values.createdTo || null);
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleActivateCustomer = (user) => {
    updateCustomerStatus(
      {
        active: true,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );
    setIsModalOpen({ ...isModalOpen, show: false });
  };

  const handleDeactivateCustomer = (user) => {
    if (user.balance > 0) {
      toast.error(
        "This Customer can't be Inactive because it has a non-zero balance.",
      );
      return;
    }
    updateCustomerStatus(
      {
        active: false,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );

    setIsModalOpen({ ...isModalOpen, show: false });
  };

  useIdleLogout();

  const openModal = (action, user) => {
    let modalMessage = "";
    let modalTitle = "";
    let type = "";
    let modalIcon = null;
    let actionHandler = () => { };

    if (action === "delete") {
      type = "danger";
      modalMessage = "Are you sure you want to delete this customer?";
      modalTitle = "Delete Customer";
      modalIcon = <IconTrash />;
      // actionHandler = () => handleDeleteUser(user);
    } else if (action === "activate") {
      type = "warning";
      modalMessage = "Are you sure you want to activate this customer?";
      modalTitle = "Activate Customer";
      modalIcon = <IconUserCheck />;
      actionHandler = () => handleActivateCustomer(user);
    } else if (action === "deactivate") {
      type = "warning";
      modalMessage = "Are you sure you want to deactivate this customer?";
      modalTitle = "Deactivate Customer";
      modalIcon = <IconUserOff />;
      actionHandler = () => handleDeactivateCustomer(user);
    }

    setIsModalOpen({
      show: true,
      action,
      user,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const handleCloseCard = () => {
    setIsCardOpen({ show: false, auto_id: null, primary_email: null });
    fetchCustomers({ page, limit });
  };

  // useEffect(() => {
  //   fetchCustomers({ page, limit });
  // }, [page, limit]);

  const handleViewClick = (customer) => {
    setIsViewOpen({
      show: true,
      products: customer,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${customer.auto_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");

  const handleDownloadExcel = async () => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.CUSTOMER_EXCEL_DOWNLOAD,
        {
          search: searchTerm || undefined,
          type: typeFilter || undefined,
          active:
            statusFilter === "active"
              ? true
              : statusFilter === "inactive"
                ? false
                : undefined,
          created_date_from: createdFrom
            ? moment(createdFrom).format("YYYY-MM-DD")
            : undefined,
          created_date_to: createdTo
            ? moment(createdTo).format("YYYY-MM-DD")
            : undefined,
        },
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `constomers_${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed:", error);
      toast.error("Excel download failed. Please try again.");
    }
  };

  return (
    <>
      <View_DetailsProduct
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
      />
      {isCardOpen.show && (
        <CustomerCard
          show={isCardOpen.show}
          setShow={handleCloseCard}
          auto_id={isCardOpen.auto_id}
          primary_email={isCardOpen.primary_email}
        />
      )}

      {isListView ? null : (
        <>
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">Customer Management</h2>
              </div>
            </div>
          </div>

          {/* New toolbar layout (mirrors OpportunityListing shared filter bar) — same search/download working as the Card below */}
          {/* <Card className="mb-2 shadow-sm">
            <Card.Body className="p-3">
              <Form
                className="d-flex align-items-center gap-4 position-relative"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              >
                <InputGroup>
                  <Form.Control
                    className="bg-light shadow-none"
                    placeholder="Search anything..."
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                    autoComplete="off"
                  />
                  <InputGroup.Text className="bg-white border-start-0">
                    <IconSearch stroke={2} />
                  </InputGroup.Text>
                </InputGroup>

                <div className="d-flex align-items-center gap-2 border_filter position-relative">
                  <Button
                    ref={filterBtnRef}
                    className="filter-btn"
                    onClick={() => setShowFiltersModal((p) => !p)}
                  >
                    <IconFilter size={16} />
                    <span>Filters</span>
                    {(typeFilter || statusFilter || createdFrom || createdTo) && (
                      <span
                        className="ms-1 badge rounded-pill text-white"
                        style={{
                          backgroundColor: "#fe6338",
                          fontSize: 11,
                          padding: "2px 6px",
                        }}
                      >
                        {
                          [typeFilter, statusFilter, createdFrom || createdTo]
                            .filter(Boolean).length
                        }
                      </span>
                    )}
                  </Button>

                  <Filters
                    show={showFiltersModal}
                    onHide={() => setShowFiltersModal(false)}
                    anchorRef={filterBtnRef}
                    initialValues={{
                      type: typeFilter,
                      status: statusFilter,
                      createdFrom,
                      createdTo,
                    }}
                    matchCount={filteredTotal}
                    totalCount={globalTotal}
                    onApply={handleFiltersApply}
                  />
                </div>

                <div className="d-flex align-items-center gap-2 border_filter">
                  <Button variant="warning" onClick={handleSearch}>
                    <IconSearch size={16} /> Search
                  </Button>
                  <Button
                    variant="outline-success"
                    onClick={handleDownloadExcel}
                    className="d-flex align-items-center gap-1"
                  >
                    <IconFileTypeXls size={16} /> Download
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card> */}
          {/* New toolbar layout */}

          <Card className="mb-3">
            <CardBody>
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              >
                <Row className="align-items-end">
                  <Col md={8}>
                    <Form.Label>Search Customer</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconSearch />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </InputGroup>
                  </Col>

                  <Col md={4}>
                    <div className="d-flex gap-2">
                      <Button
                        className="w-100"
                        variant="warning"
                        onClick={handleSearch}
                      >
                        Apply Filters
                      </Button>
                      <Button
                        className="w-100"
                        variant="outline-secondary"
                        onClick={handleClearSearch}
                      >
                        Clear Filters
                      </Button>
                      <Button
                        className="w-100 d-flex align-items-center justify-content-center gap-1"
                        variant="outline-success"
                        onClick={handleDownloadExcel}
                      >
                        <IconFileTypeXls size={16} /> Download
                      </Button>
                    </div>
                  </Col>
                  <Form.Text>
                    Search by Customer's name, Person's name, or any other
                    relevant keyword.
                  </Form.Text>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </>
      )}

      {isListView ? null : (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      )}

      {isListView ? (
        <CustomerListUI />
      ) : (
        <>
          <Row>
            {customers?.data?.map((customer, index) => (
              <Col md={3} key={index}>
                <Card
                  className="status_item_card w-100 mb-4"
                  onClick={() => handleViewClick(customer)}
                  style={{ cursor: "pointer" }}
                >
                  <Card.Body>
                    <div className="rfq_card_row">
                      <div className="rfq_item_card">
                        <div className="value_card d-flex align-items-center">
                          Type:{" "}
                          <p className="label_card listing_label">
                            &nbsp; {customer?.type || "NA"}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="rfq_card_row full_context">
                      <div className="rfq_item_card">
                        <div className="value_card">Person's Name</div>
                        <p className="label_card">
                          {customer?.display_name || "N/A"}
                        </p>
                      </div>
                      <div className="rfq_item_card">
                        <div className="value_card">
                          {" "}
                          {customer?.type === "INDIVIDUAL"
                            ? "Person's Contact"
                            : "Contracting Officer"}
                        </div>
                        <p className="label_card">
                          {/* {`${customer.first_name} ${customer.last_name}`} */}
                          {customer?.first_name || customer?.last_name
                            ? `${customer.first_name || ""} ${customer.last_name || ""
                              }`.trim()
                            : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="rfq_card_row">
                      <div className="rfq_item_card">
                        <div className="value_card">Phone Number</div>
                        <p className="label_card">
                          {customer?.primary_phone
                            ? typeof customer.primary_phone === "string"
                              ? JSON.parse(customer.primary_phone)
                                ?.FreeFormNumber || "N/A"
                              : customer.primary_phone?.FreeFormNumber || "N/A"
                            : "N/A"}
                        </p>
                      </div>
                      <div className="rfq_item_card">
                        <div className="value_card">Created Date</div>
                        <p className="label_card">
                          {moment(customer?.createdAt).format("MM/DD/YYYY")}
                        </p>
                      </div>
                    </div>

                    <div className="rfq_card_row">
                      <div className="rfq_item_card">
                        <div className="value_card">Email Address</div>
                        <p className="label_card">
                          {customer?.primary_email
                            ? typeof customer.primary_email === "string"
                              ? JSON.parse(customer.primary_email)?.Address ||
                              "N/A"
                              : customer.primary_email?.Address || "N/A"
                            : "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="button-groups mb-3">
                      <div className="badge_btn">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewClick(customer);
                          }}
                        >
                          <IconEye size={24} />
                        </span>
                        <b> View Details </b>
                      </div>
                      <div className="badge_btn">
                        <span
                          style={{
                            cursor: !canViewCards ? "not-allowed" : "auto",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (canViewCards) {
                              setIsCardOpen({
                                show: true,
                                auto_id: customer.auto_id,
                                primary_email: customer.primary_email,
                              });
                            }
                          }}
                        >
                          <IconBuildingBank size={24} />
                        </span>
                        <b> Payment Details </b>
                      </div>
                    </div>

                    <div className="ftr_card_box">
                      <a
                        className="big_badge bg-cyan-lt"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/customer-edit/${customer?.auto_id}`);
                        }}
                      >
                        <IconEdit width={18} height={18} /> Edit
                      </a>
                      <div className="rfq_lis_short">
                        <span>
                          <IconCreditCard stroke={1} />{" "}
                          {customer.detailsCount ?? 0}
                        </span>
                        <span>
                          <IconPaperclip stroke={1} />{" "}
                          {customer.Attachments?.length ?? 0}
                        </span>
                        <span>
                          <IconMessageCircle stroke={1} />{" "}
                          {customer.section.reduce((acc, section) => {
                            return acc + section.notes.length;
                          }, 0)}
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {customers?.data?.length > 0 && (
            <DynamicPagination
              totalPages={customers?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
              limitOptions={[50, 75, 100, 200]}
            />
          )}
        </>
      )}
    </>
  );
};

export default ContactList;
